import { useEffect } from 'react';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';

export default function AdmissionResultsPage() {
  // Set page title and meta tags
  useEffect(() => {
    document.title = '미래인재학원 대입실적 - 민락·옥정·지행';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '🎓 7년간 의대 6건, SKY 16건, 인서울 429건 합격! 민락·옥정·지행 미래인재학원 실제 합격생 명단과 학교별 상세 합격 현황을 지금 공개합니다');
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '미래인재학원 대입 합격 실적 - 의정부 민락, 양주 옥정, 동두천 지행 입시 결과');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', '🎓 7년간 의대 6건, SKY 16건, 인서울 429건 합격! 민락·옥정·지행 미래인재학원 실제 합격생 명단과 학교별 상세 합격 현황을 지금 공개합니다');
    }
  }, []);

  // ImageObject Schema for hero background image
  useEffect(() => {
    const imageSchema = {
      '@context': 'https://schema.org',
      '@type': 'ImageObject',
      'name': '미래인재학원 대입 합격 실적 배경 이미지',
      'description': '의정부 민락, 양주 옥정, 동두천 지행 미래인재학원의 대입 합격 실적을 상징하는 대학 캠퍼스 이미지. 서울대, 연세대, 고려대, 의대 등 명문대 합격생을 배출한 입시 전문 학원.',
      'contentUrl': 'https://public.readdy.ai/ai/img_res/3cbfe1b959d08b7574e4b7f7e5b8a71e.jpg',
      'url': 'https://eliteoffuture1.com/results/admission',
      'width': {
        '@type': 'QuantitativeValue',
        'value': 1920,
        'unitCode': 'E37'
      },
      'height': {
        '@type': 'QuantitativeValue',
        'value': 800,
        'unitCode': 'E37'
      },
      'encodingFormat': 'image/jpeg',
      'representativeOfPage': true,
      'creator': {
        '@type': 'EducationalOrganization',
        'name': '미래인재학원',
        'url': 'https://eliteoffuture1.com/'
      },
      'copyrightHolder': {
        '@type': 'EducationalOrganization',
        'name': '미래인재학원'
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(imageSchema);
    script.id = 'admission-image-schema';
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById('admission-image-schema');
      if (existing) existing.remove();
    };
  }, []);

  const inSeoulUniversities2026 = [
    { university: '의대', count: 2 },
    { university: '약대', count: 1 },
    { university: '고려대', count: 4, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/561e2c3ccda0839831b32f9cc0236fae.png' },
    { university: '연세대', count: 2, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/ce5f8dba24deb17ce244240733929d02.png' },
    { university: '서강대', count: 3 },
    { university: '성균관대', count: 1 },
    { university: '한양대', count: 3 },
    { university: '중앙대', count: 5 },
    { university: '경희대', count: 2, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/d0e0e3f8c5e8e5e8e5e8e5e8e5e8e5e8.png' },
    { university: '한국외대', count: 3 },
    { university: '서울시립대', count: 5 },
    { university: '건국대', count: 2 },
    { university: '동국대', count: 5 },
    { university: '홍익대', count: 1 },
    { university: '숙명여대', count: 4 },
    { university: '유니스트', count: 1 },
    { university: '교대', count: 3 },
  ];

  const inSeoulUniversities2025 = [
    { university: '의대', count: 2 },
    { university: '약대', count: 1 },
    { university: '서울대', count: 1 },
    { university: '고려대', count: 1, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/561e2c3ccda0839831b32f9cc0236fae.png' },
    { university: '연세대', count: 1, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/ce5f8dba24deb17ce244240733929d02.png' },
    { university: '포스텍', count: 1 },
    { university: '서강대', count: 1 },
    { university: '성균관대', count: 2 },
    { university: '한양대', count: 3 },
    { university: '이화여대', count: 2 },
    { university: '중앙대', count: 4 },
    { university: '경희대', count: 4, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/d0e0e3f8c5e8e5e8e5e8e5e8e5e8e5e8.png' },
    { university: '한국외대', count: 4 },
    { university: '서울시립대', count: 2 },
    { university: '건국대', count: 9 },
    { university: '동국대', count: 7 },
    { university: '홍익대', count: 3 },
  ];

  const inSeoulUniversities2024 = [
    { university: '서강대', count: 1 },
    { university: '성균관대', count: 2 },
    { university: '한양대', count: 2 },
    { university: '중앙대', count: 3 },
    { university: '경희대', count: 1, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/d0e0e3f8c5e8e5e8e5e8e5e8e5e8e5e8.png' },
    { university: '한국외대', count: 1 },
    { university: '서울시립대', count: 1 },
    { university: '이화여대', count: 1 },
    { university: '건국대', count: 3 },
    { university: '동국대', count: 1 },
  ];

  const inSeoulUniversities2023 = [
    { university: '의대', count: 2 },
    { university: '고려대', count: 2, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/561e2c3ccda0839831b32f9cc0236fae.png' },
    { university: '연세대', count: 1, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/ce5f8dba24deb17ce244240733929d02.png' },
    { university: '서강대', count: 3 },
    { university: '성균관대', count: 1 },
    { university: '한양대', count: 4 },
    { university: '이화여대', count: 2 },
    { university: '교대', count: 2 },
    { university: '중앙대', count: 1 },
    { university: '경희대', count: 4, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/d0e0e3f8c5e8e5e8e5e8e5e8e5e8e5e8.png' },
    { university: '한국외대', count: 1 },
    { university: '건국대', count: 1 },
    { university: '동국대', count: 4 },
  ];

  const inSeoulUniversities2022 = [
    { university: '연세대', count: 1, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/ce5f8dba24deb17ce244240733929d02.png' },
    { university: '한양대', count: 2 },
    { university: '이화여대', count: 1 },
    { university: '중앙대', count: 1 },
    { university: '경희대', count: 1, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/d0e0e3f8c5e8e5e8e5e8e5e8e5e8e5e8.png' },
    { university: '한국외대', count: 3 },
    { university: '서울시립대', count: 1 },
    { university: '동국대', count: 2 },
    { university: '유니스트', count: 1 },
  ];

  const inSeoulUniversities2021 = [
    { university: '서울대', count: 1 },
    { university: '연세대', count: 1, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/ce5f8dba24deb17ce244240733929d02.png' },
    { university: '고려대', count: 1, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/561e2c3ccda0839831b32f9cc0236fae.png' },
    { university: '서강대', count: 1 },
    { university: '성균관대', count: 1 },
    { university: '한양대', count: 1 },
    { university: '경희대', count: 1, logo: 'https://static.readdy.ai/image/2e28ff317bf3b761880ac8d7949ab85c/d0e0e3f8c5e8e5e8e5e8e5e8e5e8e5e8.png' },
    { university: '한국외대', count: 1 },
    { university: '서울시립대', count: 1 },
    { university: '동국대', count: 2 },
    { university: '홍익대', count: 1 },
    { university: '교대', count: 3 },
  ];

  const yearSections = [
    {
      year: '2026',
      data: inSeoulUniversities2026,
      total: 130,
      link: '',
    },
    {
      year: '2025',
      data: inSeoulUniversities2025,
      total: 129,
      link: 'https://blog.naver.com/eliteoffuture/223825281859',
    },
    {
      year: '2024',
      data: inSeoulUniversities2024,
      total: 45,
      link: 'https://blog.naver.com/eliteoffuture/223377223405',
    },
    {
      year: '2023',
      data: inSeoulUniversities2023,
      total: 50,
      link: 'https://blog.naver.com/eliteoffuture/222979095876',
    },
    {
      year: '2022',
      data: inSeoulUniversities2022,
      total: 38,
      link: 'https://blog.naver.com/eliteoffuture/222616961581',
    },
    {
      year: '2021',
      data: inSeoulUniversities2021,
      total: 37,
      link: 'https://blog.naver.com/eliteoffuture/222281759739',
    },
  ];

  const admissionData = [
    {
      year: 2023,
      total: 50,
      link: 'https://blog.naver.com/eliteoffuture/222979095876',
      universities: [
        { name: '의대', count: 2 },
        { name: '고려대', count: 2 },
        { name: '연세대', count: 1 },
        { name: '서강대', count: 3 },
        { name: '성균관대', count: 1 },
        { name: '한양대', count: 4 },
        { name: '이화여대', count: 2 },
        { name: '교대', count: 2 },
        { name: '중앙대', count: 1 },
        { name: '경희대', count: 4 },
        { name: '한국외대', count: 1 },
        { name: '건국대', count: 1 },
        { name: '동국대', count: 4 },
      ],
    },
    {
      year: 2024,
      total: 45,
      link: 'https://blog.naver.com/eliteoffuture/223377223405',
      universities: [
        { name: '서강대', count: 1 },
        { name: '성균관대', count: 2 },
        { name: '한양대', count: 2 },
        { name: '중앙대', count: 3 },
        { name: '경희대', count: 1 },
        { name: '한국외대', count: 1 },
        { name: '서울시립대', count: 1 },
        { name: '이화여대', count: 1 },
        { name: '건국대', count: 3 },
        { name: '동국대', count: 1 },
      ],
    },
    {
      year: 2025,
      total: 52,
      universities: [
        { name: '서울대', count: 1 },
        { name: '연세대', count: 2 },
        { name: '고려대', count: 3 },
        { name: '서강대', count: 2 },
        { name: '성균관대', count: 4 },
        { name: '한양대', count: 5 },
        { name: '중앙대', count: 3 },
        { name: '경희대', count: 4 },
        { name: '한국외대', count: 2 },
        { name: '서울시립대', count: 2 },
        { name: '이화여대', count: 3 },
        { name: '건국대', count: 4 },
        { name: '동국대', count: 3 },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-neutral-950">
      <Navigation currentPage="results" />

      {/* Hero Section */}
      <section className="pt-20 relative min-h-[600px] flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-black to-gray-900">
          <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/90"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
          <div className="text-center">
            <div className="inline-block px-6 py-2 bg-yellow-400/20 border border-yellow-400/40 rounded-full mb-8">
              <span className="text-yellow-400 text-sm font-semibold tracking-wide">ELITE OF FUTURE</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
              미래인재학원<br />
              <span className="text-yellow-400">빛나는 대입실적</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-4 leading-relaxed max-w-3xl mx-auto">
              <span className="md:hidden">체계적인 교육과 열정으로 이루어낸<br />자랑스러운 성과</span>
              <span className="hidden md:inline">체계적인 교육과 열정으로 이루어낸 자랑스러운 성과</span>
            </p>
            <p className="text-sm text-gray-500 mb-12">(21~26년도 총합, 중복 합격 포함, 민락 옥정 지행 전 지점 합산)</p>

            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
              {/* 의대 */}
              <div className="bg-gradient-to-br from-red-500/20 to-red-600/10 backdrop-blur-sm border-2 border-red-400/30 rounded-2xl p-8 hover:scale-105 transition-transform duration-300">
                <div className="text-xl font-semibold text-white mb-4 text-center">
                  의대 합격
                </div>
                <div className="text-6xl font-bold text-red-400 text-center">6건</div>
              </div>

              {/* SKY */}
              <div className="bg-gradient-to-br from-yellow-500/20 to-yellow-600/10 backdrop-blur-sm border-2 border-yellow-400/30 rounded-2xl p-8 hover:scale-105 transition-transform duration-300">
                <div className="text-xl font-semibold text-white mb-4 text-center">
                  SKY 합격
                </div>
                <div className="text-6xl font-bold text-yellow-400 text-center">16건</div>
              </div>

              {/* 인서울 */}
              <div className="bg-gradient-to-br from-blue-500/20 to-blue-600/10 backdrop-blur-sm border-2 border-blue-400/30 rounded-2xl p-8 hover:scale-105 transition-transform duration-300">
                <div className="text-xl font-semibold text-white mb-4 text-center">
                  인서울 합격
                </div>
                <div className="text-6xl font-bold text-blue-400 text-center">429건</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Results Sections */}
      {yearSections.map((section, sectionIndex) => (
        <section
          key={section.year}
          className={`py-20 ${
            sectionIndex % 2 === 0
              ? 'bg-neutral-950'
              : 'bg-neutral-900'
          }`}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col lg:flex-row items-center lg:items-start justify-between mb-12 gap-8 text-center lg:text-left">
              <div className="flex flex-col items-center lg:items-start">
                <div className="text-4xl font-bold text-white mb-4">
                  {section.year}학년도 <span className="text-yellow-400">합격현황</span>
                </div>
                <p className="text-sm lg:text-lg text-neutral-400 mb-4">주요 인서울 대학 합격자 현황 (중복 합격 포함)</p>
                <a
                  href="https://blog.naver.com/eliteoffuture/224194635261"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-yellow-400 hover:bg-yellow-300 text-black font-semibold rounded-lg transition-all shadow-lg shadow-yellow-400/25 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-file-list-3-line"></i>
                  자세히 명단보기
                </a>
              </div>

              {/* Total Count Box */}
              <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 p-8 rounded-2xl border-2 border-yellow-300 shadow-2xl shadow-yellow-400/20 min-w-[200px]">
                <div className="text-center">
                  <div className="text-5xl font-black text-black mb-2">{section.total}건</div>
                  <div className="text-black font-bold text-lg">인서울 총 합격</div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2 md:gap-4">
              {section.data.map((item, index) => (
                <div
                  key={index}
                  className="bg-neutral-800/50 p-3 md:p-6 rounded-xl border border-neutral-700 hover:border-yellow-400/50 transition-all duration-300 text-center"
                >
                  <h3 className="text-sm md:text-lg font-bold text-white mb-1 md:mb-2">{item.university}</h3>
                  <div className="text-xl md:text-3xl font-black text-yellow-400">{item.count}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* Footer */}
      <Footer />
    </div>
  );
}
